import VideoInternal from './VideoInternal';

export default VideoInternal;